import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import BRSRSidebar from "../../../Layout/BRSRSidebar";
import GeneralInstructions from "./GeneralInstructions";

const index = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      <GeneralInstructions />
    </MainDashboardLayout>
  );
};

export default index;
